import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateEventFinancialService, type UpdateFinancialPayload } from '@/services/events'
import { eventDetailsQueryKey } from './useEventDetails'

export const useUpdateEventFinancial = (agendaId: string, eventId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: UpdateFinancialPayload) =>
      updateEventFinancialService(agendaId, eventId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: eventDetailsQueryKey(agendaId, eventId) })
      queryClient.invalidateQueries({ queryKey: ['calendar'] })
    },
  })
}
